import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { BaseComponent, UserService, WindowService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-giveaway-gifts-splash",
  templateUrl: "giveaway-gifts-splash.component.html",
  standalone: false,
})
export class GiveawayGiftsSplashComponent extends BaseComponent implements OnInit {
  @Input() gifts: any[] = [];
  @Input() registeredProductName: string;

  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    private _win: WindowService,
    private appService: AppService
  ) {
    super(userService);
  }

  ngOnInit() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.add("clear-modal-content");
    this._win.setTimeout(() => {
      this.appService.showConfetti();
    }, 400);
  }

  close() {
    this.activeModal.close();
  }

  ngOnDestroy() {
    let body = document.getElementsByTagName("body")[0];
    body.classList.remove("clear-modal-content");
  }
}
